/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CreateApplicationFlowRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateApplicationFlowResponse": {
                "fields": {
                  "applicationFlow": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreateApplicationFlowRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreateApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateApplicationFlowRequest @ squareup/corporate_card/service/create_application_flow.proto at 10:1
 */
export const CreateApplicationFlowRequest = $root.lookupType('squareup.corporate_card.service.CreateApplicationFlowRequest');
fixType(CreateApplicationFlowRequest, {
  idempotencyKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateApplicationFlowRequest);
/**
 * SOURCE CreateApplicationFlowResponse @ squareup/corporate_card/service/create_application_flow.proto at 19:1
 */
export const CreateApplicationFlowResponse = $root.lookupType('squareup.corporate_card.service.CreateApplicationFlowResponse');
fixType(CreateApplicationFlowResponse);
Builder.createAndAttachToType(CreateApplicationFlowResponse);